/* eslint-disable no-param-reassign */
// @flow
import React, { Component } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import { AllMachines } from 'pages/CardSwapDashboard/components';
import { Container } from './CardSwapDashboard.style';

type StateType = {
  time: number,
};
export type StatePropsType = {
  logs: any,
};
export type DispatchPropsType = {
  fetchAllLogsRequest: Function,
};
declare type Props = StatePropsType & DispatchPropsType;

class CardSwapDashboard extends Component<Props & DispatchPropsType, StateType> {
  interval: IntervalID;

  constructor(props) {
    super(props);
    this.state = {
      time: Date.now(),
    };
  }

  componentDidMount() {
    this.fetchData();
    this.interval = setInterval(() => this.setState({}, this.fetchData), 20000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchData = () => {
    const { time } = this.state;
    if ((Date.now() - time) / (5 * 60 * 1000) > 1) {
      window.location.reload(false);
    }
    const { fetchAllLogsRequest } = this.props;
    fetchAllLogsRequest();
  };

  render() {
    const { logs } = this.props;
    return (
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1}>
            <Grid spacing={1} md={12}>
              <AllMachines data={logs} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    );
  }
}

export default CardSwapDashboard;
